import { useReduxState } from 'hooks';

interface Props {
  question: string;
}

const TaskQuestion = ({ question }: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="question">
      <div dangerouslySetInnerHTML={{ __html: question }} />

      <style jsx>{`
        .question {
          color: ${theme.textColorLight};
          font-size: 1.6rem;
          font-weight: 400;
          margin-bottom: 15px;
        }
        .question :global(p) {
          margin: 0;
        }
      `}</style>
    </div>
  );
};

export default TaskQuestion;
